<template>    
    <v-container fluid>        
        <v-row>
            <v-col cols="12" class="pa-0">
                <barraaplicacion titulo="Del Ahorro Supertiendas" />
            </v-col>
        </v-row>

        <br><br><br><br>

        <v-row>
            <v-col xs='12' md='5'>
                <strong class="display-3">Boletos: {{cantidadBoletos}}</strong>
            </v-col>
        </v-row>

        <v-row class="d-flex justify-center">
            <v-col cols="5" xs="2" sm="2" md="1" v-for="(suc, key) in pedidosPorSucursal" :key="key">                
                <v-card>
                    <v-card-title class="primary--text d-flex justify-center"> 
                        <v-chip  outlined label color="green">{{suc.sucursal}}</v-chip>
                    </v-card-title>                                        
                    
                    <div class="d-flex justify-center pr-1"><strong class="display-3">{{suc.cantidad}}</strong></div>
                </v-card>                
            </v-col>            
        </v-row>

        <v-dialog v-model="dialogo" persistent hide-overlay width="300">
            <div class="resaltar pa-6">
                <strong>{{dialogo_msj}}</strong>
                <v-progress-linear indeterminate color="primary" class="mt-3"></v-progress-linear>    
            </div>
        </v-dialog>

    </v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import cookie from 'vue-cookie'
import barraaplicacion from '@/components/BarraAplicacion'
export default {

    components:{
        barraaplicacion
    },

    data() {
        return {
            token: Object,
            fecha: String,
            menu: false,
            dialogo: false,      
            dialogo_msj: '',  

            pedidosPorSucursal: [],

        }
    },

    computed: {
        cantidadBoletos(){
            let total = 0
            this.pedidosPorSucursal.forEach(el => {
                total += el.cantidad
            });

            return total
        }
    },

    methods: {        

        boletosPorSucursal(){
            axios.get(this.$url+'/delahorro/boletosxsuc')
                .then((response)=>{
                    this.pedidosPorSucursal = response.data.data
                })
                .catch((error)=>{
                    console.log("Error al consultar información");
                })                
        },


        totalpedidos: function(){
            let fec = moment(this.fecha).format('YYYYMMDD')
            this.dialogo = true
            this.dialogo_msj = "Consultando información."
                                                          
            axios.get(this.$url+'/delahorro/totalpedidosdiaxestatus/'+fec, 
                    {headers:{Authorization: `Bearer ${this.token}`}})
                .then((response)=>{                    
                    this.dialogo = false
                    let data = response.data;
                    if(data.estatus){
                        for(let ped of data.pedidos){
                            if(ped.estatus == 'PP')
                                this.pedidos_ensurtimiento = ped.pedidos
                            if(ped.estatus == 'PS')
                                this.pedidos_surtidos = ped.pedidos
                            if(ped.estatus == 'PR')
                                this.pedidos_enreparto = ped.pedidos
                            if(ped.estatus == 'PC')
                                this.pedidos_cancelados = ped.pedidos
                            if(ped.estatus == 'PE')
                                this.pedidos_entregados = ped.pedidos
                        }

                    }
                })
                .catch((error)=>{
                    this.dialogo = false
                })
        },
    },

    created() {
         //Establecer fecha de busqueda 
        this.fecha = moment().format('YYYY-MM-DD');

        this.token = cookie.get('token')        
        if(this.token ===  '' || this.token === null ){     
            this.$router.push({name:'Login'});
        }
        else{
            this.boletosPorSucursal()
        }
    },
}

</script>